module.exports = __webpack_public_path__ + "static/media/center.f2a7df5d.jpg";